import { type OpenApiSchemaProductVariantWithSettings } from '#shared/api/schema';
import { createGetByIdHookWithPreviewData } from '#shared/lib/requests';
import { api } from '../api/api';

function isVariantModel(data: unknown): data is Partial<OpenApiSchemaProductVariantWithSettings> {
    return typeof data === 'object' && data !== null && ('product_id' in data || 'media' in data || 'name' in data);
}

export const useProductVariantGetByIdWithPreviewData = createGetByIdHookWithPreviewData<
    OpenApiSchemaProductVariantWithSettings,
    'product',
    | 'Variant'
    | 'ProductVariant'
    | 'Product'
    | 'CardGrid'
    | 'CardTemp'
    | 'VariantsGrid'
    | 'ArchivedVariantsGrid'
    | 'CardsGrid'
    | 'VariantsCount'
    | 'CardsCount'
>({
    validatePreviewData: isVariantModel,
    endpoint: api.endpoints.getProductVariantById,
});
